import { AJAX_URL } from '../../../config/index.js';

/**
 * Submit a standard WordPress admin-ajax.php request
 * using application/x-www-form-urlencoded format
 */
export const wpAjax = async (action, params = {}) => {
  const formData = new URLSearchParams();
  formData.append('action', action);

  // Append any other parameters
  Object.entries(params).forEach(([key, value]) => {
    formData.append(key, value);
  });

  const response = await fetch(AJAX_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: formData.toString()
  });

  const json = await response.json();

  if (!json.success) {
    throw new Error(json.data || 'Request failed');
  }

  return json.data;
};
